import { store } from 'react-notifications-component'

enum NotificationType {
  success = 'success',
  default = 'default',
  warning = 'warning',
  danger = 'danger',
}

export interface RaaSNotification {
  title: string
  message: string
}

export const showSuccessNotification = (notification: RaaSNotification) =>
  showNotification(notification, NotificationType.success)

export const showDefaultNotification = (notification: RaaSNotification) =>
  showNotification(notification, NotificationType.default)

export const showWarningNotification = (notification: RaaSNotification) =>
  showNotification(notification, NotificationType.warning)

export const showErrorNotification = (notification: RaaSNotification) =>
  showNotification(notification, NotificationType.danger)

const showNotification = (notification: RaaSNotification, type: string) =>
  pushNotification(store, notification, type)

const pushNotification = (
  notificationStore: any,
  notification: RaaSNotification,
  type: string
) => {
  notificationStore.addNotification({
    title: notification.title,
    message: notification.message,
    type: type,
    insert: 'bottom',
    container: 'bottom-center',
    animationIn: ['animated', 'bounceIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 0,
      showIcon: true,
    },
  })
}
